<template>
    <div>
        <button class="button is-small" :class="hasPaid" v-if="balance">
            <span v-if="balance > 0">{{ balance | formatNumber}}{{ currency }}</span>
            <span v-else>{{ balance }}</span>
        </button>
        <button class="button is-small" v-else>PENDING</button>
    </div>
</template>

<script>
    export default {
        props:['car'],
        computed: {
            hasPaid() {
                let percent = (this.car.proforma_invoice.paid_amount / this.car.proforma_invoice.balance_due) * 100

                 if (percent < 30) {
                    return 'is-danger'
                } else if (percent >= 30 && percent < 50) {
                    return 'is-warning'
                } else if (percent >= 50 && percent < 100) {
                    return 'is-purple'
                } else {
                    return 'is-success'
                }
            },
            balance() {
                if (this.car.proforma_invoice !== null) {
                    let balance = this.car.proforma_invoice.balance_due - this.car.proforma_invoice.paid_amount
                    if (balance  > 0) {
                        return balance
                    } else {
                        return 'PAID'
                    }
                } else {
                    return false
                }
            },
            currency() {
                if (this.car.proforma_invoice.currency == this.$currencyIsJpy ) {
                    return '¥'
                } else {
                    return '$'
                }
            }
        }
    }
</script>

<style scoped>
    .button {
        min-width: 90px;
    }
    .is-purple {
        background-color: #ff00f1;
        border-color: transparent;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/BalanceColumn.vue